/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateAssignmentRuleRequest
 */
export interface CreateAssignmentRuleRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateAssignmentRuleRequest
     */
    facility_id?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateAssignmentRuleRequest
     */
    source_id?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateAssignmentRuleRequest
     */
    connector?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateAssignmentRuleRequest
     */
    owner_user_id?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateAssignmentRuleRequest
     */
    liaison_user_ids?: Array<string>;
}

/**
 * Check if a given object implements the CreateAssignmentRuleRequest interface.
 */
export function instanceOfCreateAssignmentRuleRequest(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CreateAssignmentRuleRequestFromJSON(json: any): CreateAssignmentRuleRequest {
    return CreateAssignmentRuleRequestFromJSONTyped(json, false);
}

export function CreateAssignmentRuleRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateAssignmentRuleRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'facility_id': !exists(json, 'facility_id') ? undefined : json['facility_id'],
        'source_id': !exists(json, 'source_id') ? undefined : json['source_id'],
        'connector': !exists(json, 'connector') ? undefined : json['connector'],
        'owner_user_id': !exists(json, 'owner_user_id') ? undefined : json['owner_user_id'],
        'liaison_user_ids': !exists(json, 'liaison_user_ids') ? undefined : json['liaison_user_ids'],
    };
}

export function CreateAssignmentRuleRequestToJSON(value?: CreateAssignmentRuleRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'facility_id': value.facility_id,
        'source_id': value.source_id,
        'connector': value.connector,
        'owner_user_id': value.owner_user_id,
        'liaison_user_ids': value.liaison_user_ids,
    };
}

